var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: _vm.size, height: _vm.size})},[_c('statistic-pie',{attrs:{"chart-data":_vm.evidenceStatus},on:{"entry-selected":_vm.entrySelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }